import { Pack, Repack } from 'types/generated/graphql';
import { LabelPacks, Artwork } from '../types';

export const getSlideArtworks = (
    entities?: Pack | Repack | LabelPacks,
    optimizedSize = 500,
): [Artwork, Artwork, Artwork] | undefined => {
    if (!entities) {
        return undefined;
    }

    const isArray = Array.isArray(entities);

    if (isArray && entities.some((item) => item === undefined)) {
        return undefined;
    }

    const optimizedImage = isArray
        ? entities.map((entity) => {
              return {
                  isExclusive: entity?.isExclusive ?? false,
                  artworkUrl: entity?.artworkUrl ?? '',
              };
          })
        : [
              {
                  isExclusive: entities?.isExclusive ?? false,
                  artworkUrl: entities?.artworkUrl ?? '',
              },
          ];

    const main = optimizedImage[0];
    const left = isArray ? optimizedImage[1] : main;
    const right = isArray ? optimizedImage[2] : main;

    return [main, left, right];
};
